import { render } from "./Web_hosting.vue?vue&type=template&id=0107cf00"
import script from "./Web_hosting.vue?vue&type=script&lang=js"
export * from "./Web_hosting.vue?vue&type=script&lang=js"
script.render = render

export default script